import React from 'react';
import Icon from '../../../components/AppIcon';

const CommunicationProtocol = ({ protocols }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {protocols?.map((protocol, index) => (
        <div 
          key={index}
          className="p-6 md:p-8 bg-card border border-border rounded-2xl hover:border-primary/50 transition-all duration-300"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name={protocol?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-base md:text-lg font-bold text-foreground mb-2">
                {protocol?.title}
              </h4>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {protocol?.description}
              </p>
              {protocol?.frequency && (
                <div className="mt-3 inline-flex items-center gap-2 px-3 py-1 bg-muted rounded-full text-xs font-medium text-muted-foreground">
                  <Icon name="Calendar" size={12} />
                  {protocol?.frequency}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommunicationProtocol;